import { useQuery } from "@tanstack/react-query";
import { getDriversReport } from "@/api/reports";
import { DriversOnTimeChart } from "@/features/reports/components/DriversOnTimeChart";
import { DriversReportTable } from "@/features/reports/components/DriversReportTable";
import type { ReportParams } from "@/types/reports";

interface Props {
  params: ReportParams;
  visibleKeys: string[];
}

/**
 * Drivers tab on the Reports page (TASK-3729): runs the driver scorecard query
 * once and renders the on-time chart above the sortable table.
 */
export function DriversReportTab({ params, visibleKeys }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ["reports", "drivers", params],
    queryFn: () => getDriversReport(params),
  });

  const rows = data?.results ?? [];

  return (
    <div className="space-y-4">
      {!isLoading && rows.length > 0 && <DriversOnTimeChart rows={rows} />}
      <DriversReportTable
        rows={rows}
        isLoading={isLoading}
        visibleKeys={visibleKeys}
      />
    </div>
  );
}
